/* ============================================================
   AURAEL — Main JS v6
   ============================================================ */

'use strict';

/* -- Scroll: Header state ------------------------------------- */
(function () {
  var header = document.querySelector('.site-header');
  if (!header) return;
  var ticking = false;

  function onScroll() {
    if (window.scrollY > 60) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
    ticking = false;
  }

  function requestHeaderUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(onScroll);
  }

  window.addEventListener('scroll', requestHeaderUpdate, { passive: true });
  onScroll();
})();

/* -- Mobile Nav ----------------------------------------------- */
(function () {
  var hamburger = document.querySelector('.header-hamburger');
  var mobileNav = document.querySelector('.mobile-nav');
  var overlay   = document.querySelector('.mobile-nav__overlay');
  var closeBtn  = document.querySelector('.mobile-nav__close');

  if (!hamburger || !mobileNav) return;

  function openNav() {
    mobileNav.classList.add('open');
    document.body.classList.add('no-scroll');
  }
  function closeNav() {
    mobileNav.classList.remove('open');
    document.body.classList.remove('no-scroll');
  }

  hamburger.addEventListener('click', openNav);
  if (overlay)  overlay.addEventListener('click', closeNav);
  if (closeBtn) closeBtn.addEventListener('click', closeNav);
})();

/* -- Cart Drawer ---------------------------------------------- */
window.openCart = function () {
  var drawer  = document.querySelector('.cart-drawer');
  var overlay = document.querySelector('.cart-overlay');
  renderCartDrawer();
  if (drawer)  drawer.classList.add('open');
  if (overlay) overlay.classList.add('active');
  document.body.classList.add('no-scroll');
};

window.closeCart = function () {
  var drawer  = document.querySelector('.cart-drawer');
  var overlay = document.querySelector('.cart-overlay');
  if (drawer)  drawer.classList.remove('open');
  if (overlay) overlay.classList.remove('active');
  document.body.classList.remove('no-scroll');
};

(function () {
  var overlay = document.querySelector('.cart-overlay');
  if (overlay) overlay.addEventListener('click', window.closeCart);
})();

/* -- Scroll Reveal -------------------------------------------- */
(function () {
  var els = document.querySelectorAll('.reveal');
  if (!els.length) return;

  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('visible'); });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  els.forEach(function (el) { observer.observe(el); });
})();

/* -- Accordion ------------------------------------------------ */
(function () {
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.accordion-trigger');
    if (!trigger) return;

    var item = trigger.closest('.accordion-item');
    if (!item) return;

    var isOpen = item.classList.contains('open');

    var accordion = item.closest('.accordion');
    if (accordion) {
      accordion.querySelectorAll('.accordion-item.open').forEach(function (openItem) {
        if (openItem !== item) openItem.classList.remove('open');
      });
    }

    item.classList.toggle('open', !isOpen);
  });
})();

/* -- Product Image Gallery ------------------------------------ */
(function () {
  var mainImg   = document.querySelector('.pdp-main-image');
  var thumbs    = document.querySelectorAll('.pdp-thumb');

  if (!mainImg || !thumbs.length) return;

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var src = thumb.dataset.src || (thumb.querySelector('img') && thumb.querySelector('img').src);
      if (!src) return;
      mainImg.src = src;
      thumbs.forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
    });
  });
})();

/* -- Quantity Selector ---------------------------------------- */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.qty-btn');
    if (!btn) return;

    var wrap = btn.closest('.qty-selector');
    if (!wrap) return;

    var display = wrap.querySelector('.qty-value');
    var input   = wrap.querySelector('input[name="quantity"]');
    var val = parseInt(display ? display.textContent : '1', 10);

    if (btn.dataset.action === 'minus') val = Math.max(1, val - 1);
    if (btn.dataset.action === 'plus')  val = Math.min(99, val + 1);

    if (display) display.textContent = val;
    if (input)   input.value = val;
  });
})();

/* -- Subscribe Toggle ----------------------------------------- */
(function () {
  document.addEventListener('click', function (e) {
    var option = e.target.closest('.subscribe-option');
    if (!option) return;

    var wrap = option.closest('.subscribe-toggle');
    if (!wrap) return;

    wrap.querySelectorAll('.subscribe-option').forEach(function (o) {
      o.classList.remove('active');
    });
    option.classList.add('active');
  });
})();

/* -- Sticky ATC ----------------------------------------------- */
(function () {
  var mainBtn  = document.querySelector('.pdp-atc-main');
  var stickyBar = document.querySelector('.sticky-atc');
  if (!mainBtn || !stickyBar) return;

  if (!('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      stickyBar.classList.toggle('visible', !entry.isIntersecting);
    });
  }, { threshold: 0 });

  observer.observe(mainBtn);
})();

/* -- Collection Filter Tabs ----------------------------------- */
(function () {
  var tabs     = document.querySelectorAll('.filter-tab');
  var products = document.querySelectorAll('.product-card[data-category]');

  if (!tabs.length) return;

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      tabs.forEach(function (t) {
        t.classList.remove('active');
        t.setAttribute('aria-selected', 'false');
      });
      tab.classList.add('active');
      tab.setAttribute('aria-selected', 'true');

      var filter = tab.dataset.filter;

      products.forEach(function (card) {
        if (filter === 'all') {
          card.style.display = '';
        } else {
          var cats = (card.dataset.category || '').split(',').map(function (c) { return c.trim(); });
          card.style.display = cats.includes(filter) ? '' : 'none';
        }
      });
    });
  });
})();

/* -- Add to Cart (AJAX) --------------------------------------- */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-atc]');
    if (!btn) return;
    e.preventDefault();

    var form = btn.closest('form');
    var variantId = btn.dataset.variantId || (form && form.querySelector('[name="id"]') ? form.querySelector('[name="id"]').value : null);
    var qty = parseInt((form && form.querySelector('[name="quantity"]') ? form.querySelector('[name="quantity"]').value : '1'), 10);

    if (!variantId) return;

    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('Unable to add item to cart.');
      return r.json();
    })
    .then(function () {
      btn.textContent = 'Added';
      return Promise.all([updateCartCount(), renderCartDrawer()]);
    })
    .then(function () {
      setTimeout(function () {
        btn.textContent = originalText;
        btn.disabled = false;
        window.openCart();
      }, 800);
    })
    .catch(function () {
      btn.textContent = originalText;
      btn.disabled = false;
    });
  });
})();

/* -- Cart Count ----------------------------------------------- */
function updateCartCount() {
  return fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var counts = document.querySelectorAll('.cart-count');
      counts.forEach(function (el) {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    });
}

document.addEventListener('DOMContentLoaded', updateCartCount);

/* -- Cart Drawer: Render items -------------------------------- */
function renderCartDrawer() {
  return fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var body     = document.querySelector('.cart-drawer__body');
      var subtotal = document.querySelector('.cart-subtotal__value');
      var footer   = document.querySelector('[data-cart-footer]');

      if (!body) return;

      if (cart.item_count === 0) {
        body.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty.</p><a href="/collections/all" class="btn btn--secondary btn--sm" style="margin-top:1rem;">Continue Shopping</a></div>';
      } else {
        body.innerHTML = cart.items.map(function (item) {
          var safeKey = String(item.key).replace(/"/g, '&quot;');
          var title = escapeHTML(item.product_title || item.title || 'Cart item');
          var variantTitle = escapeHTML(item.variant_title || '');
          var image = item.image
            ? '<img class="cart-item__image" src="' + encodeURI(item.image) + '" alt="' + title + '" width="80" height="100" loading="lazy" decoding="async">'
            : '<div class="cart-item__image img-placeholder" aria-hidden="true"></div>';
          return '<div class="cart-item">' +
            image +
            '<div class="cart-item__info">' +
              '<div class="cart-item__name">' + title + '</div>' +
              (variantTitle && variantTitle !== 'Default Title' ? '<div class="cart-item__variant">' + variantTitle + '</div>' : '') +
              '<div class="cart-item__qty">' +
                '<button class="qty-btn" data-action="minus" data-cart-key="' + safeKey + '" data-cart-qty="' + (item.quantity - 1) + '">-</button>' +
                '<span class="qty-value">' + item.quantity + '</span>' +
                '<button class="qty-btn" data-action="plus" data-cart-key="' + safeKey + '" data-cart-qty="' + (item.quantity + 1) + '">+</button>' +
              '</div>' +
            '</div>' +
            '<div class="cart-item__price">' + formatMoney(item.line_price) + '</div>' +
          '</div>';
        }).join('');
      }

      if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
      if (footer) footer.classList.toggle('is-hidden', cart.item_count === 0);
    });
}

/* Cart qty buttons (event delegation instead of inline onclick) */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-cart-key]');
  if (!btn) return;
  var key = btn.dataset.cartKey;
  var qty = parseInt(btn.dataset.cartQty, 10);
  if (key) updateCartItem(key, qty);
});

window.updateCartItem = function (key, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  })
  .then(function () {
    renderCartDrawer();
    updateCartCount();
  });
};

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

function escapeHTML(value) {
  return String(value).replace(/[&<>"']/g, function (char) {
    return {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    }[char];
  });
}

document.addEventListener('DOMContentLoaded', renderCartDrawer);

/* -- Newsletter Popup (60-second delay) ----------------------- */
(function () {
  var popup    = document.querySelector('.newsletter-popup');
  var closeBtn = popup && popup.querySelector('.newsletter-popup__close');

  if (!popup) return;
  if (sessionStorage.getItem('aurael_popup_dismissed')) return;

  /* 60-second delay per brief requirement */
  setTimeout(function () {
    popup.classList.add('visible');
  }, 60000);

  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      popup.classList.remove('visible');
      sessionStorage.setItem('aurael_popup_dismissed', '1');
    });
  }

  popup.addEventListener('click', function (e) {
    if (e.target === popup) {
      popup.classList.remove('visible');
      sessionStorage.setItem('aurael_popup_dismissed', '1');
    }
  });
})();

/* -- Smooth scroll for anchor links --------------------------- */
document.addEventListener('click', function (e) {
  var link = e.target.closest('a[href^="#"]');
  if (!link) return;
  var target = document.querySelector(link.getAttribute('href'));
  if (!target) return;
  e.preventDefault();
  target.scrollIntoView({ behavior: 'smooth', block: 'start' });
});
